import {getConfig} from 'config';
import {getData, postData} from '../dataProvider';

export const preLaunchChecksEmailSummary = (data) => {
  return postData(`${getConfig('preLaunchCheckEmailSummary')}`, data, { responseType: 'json' });
};
